<template>
<nav class="fixed top-0 left-0 right-0 z-50 bg-white bg-opacity-95 shadow-md">
  <div class="w-full max-w-screen-2xl mx-auto px-6 py-4 flex items-center justify-between">
    <!-- Logo -->
    <div class="flex items-center">
        <router-link to="/">
            <img src="../../assets/img/logo.png" alt="AI定制服务" class="h-10">
        </router-link>
    </div>
    <!-- 移动端菜单按钮 -->
    <button class="md:hidden ml-2 text-2xl text-gray-700 focus:outline-none" @click="showMobileMenu = true">
      <i class="fas fa-bars"></i>
    </button>
    <!-- 主导航 -->
    <div class="hidden md:flex items-center space-x-4 xl:space-x-6 2xl:space-x-8">
      <router-link to="/" class="text-gray-800 hover:text-[#76B900] font-medium transition-colors duration-200 cursor-pointer text-sm md:text-base xl:text-lg 2xl:text-xl whitespace-nowrap">首页</router-link>
      <router-link to="/mall" class="text-gray-800 hover:text-[#76B900] font-medium transition-colors duration-200 cursor-pointer text-sm md:text-base xl:text-lg 2xl:text-xl whitespace-nowrap">作品商城</router-link>
      <router-link to="/category-list" class="text-gray-800 hover:text-[#76B900] font-medium transition-colors duration-200 cursor-pointer text-sm md:text-base xl:text-lg 2xl:text-xl whitespace-nowrap rainbow-category-link">
        <span v-for="(char, idx) in '定制分类'.split('')" :key="idx" class="rainbow-char" :style="{ animationDelay: (idx * 0.15) + 's' }">{{ char }}</span>
      </router-link>
      <!-- <a href="#" class="text-gray-800 hover:text-[#76B900] font-medium transition-colors duration-200 cursor-pointer text-sm md:text-base xl:text-lg 2xl:text-xl whitespace-nowrap">设计案例</a> -->
      <router-link to="/about-us" class="text-gray-800 hover:text-[#76B900] font-medium transition-colors duration-200 cursor-pointer text-sm md:text-base xl:text-lg 2xl:text-xl whitespace-nowrap">关于我们</router-link>
    </div>
    <!-- 右侧功能区 -->
    <div class="flex items-center space-x-6">
      <!-- 搜索框 -->
      <div class="relative hidden md:block">
        <input type="text" placeholder="搜索产品..."
          class="pl-10 pr-4 py-2 rounded-full border border-gray-300 focus:outline-none focus:border-[#76B900] text-sm">
        <i class="fas fa-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
      </div>
      <!-- 购物车 -->
      <div class="relative cursor-pointer" @click="goToCart">
        <i class="fas fa-shopping-cart text-gray-700 text-xl"></i>
        <span v-if="isAuthenticated" class="absolute -top-2 -right-2 bg-[#76B900] text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">{{ totalCount }}</span>
      </div>
      <!-- 用户/登录 -->
      <div v-if="!isAuthenticated" class="cursor-pointer flex items-center space-x-1" @click="goToLogin">
        <i class="fas fa-sign-in-alt text-gray-700 text-xl"></i>
        <span class="text-gray-800 font-medium text-sm md:text-base xl:text-lg 2xl:text-xl">登录</span>
      </div>
      <div v-else class="relative">
        <button type="button" class="flex items-center text-gray-800 hover:text-[#76B900] font-medium transition-colors duration-200 cursor-pointer" @click.stop="toggleDropdown">
          <span class="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center overflow-hidden mr-2">
            <img v-if="avatar" :src="avatar" alt="头像" class="w-8 h-8 object-cover rounded-full" />
            <i v-else class="fas fa-user-circle text-gray-700 text-xl"></i>
          </span>
          <span class="text-sm md:text-base xl:text-lg 2xl:text-xl">{{ username }}</span>
          <i :class="['fas', showDropdown ? 'fa-chevron-up' : 'fa-chevron-down', 'ml-1 text-xs']"></i>
        </button>
        <transition name="dropdown">
          <div v-if="showDropdown" class="absolute right-0 mt-2 w-40 bg-white rounded-md shadow-lg py-1 z-50">
            <div class="px-4 py-2 text-sm text-gray-700 flex items-center">
              <i class="fas fa-wallet mr-2 text-[#76B900]"></i>
              <span>余额：</span>
              <span class="ml-1 text-[#76B900] font-bold">¥{{ amount }}</span>
            </div>
            <div class="border-t border-gray-100 my-1"></div>
            <a href="#" @click.prevent="goToUserProfile" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
              <i class="fas fa-user mr-2"></i>个人中心
            </a>
            <div class="border-t border-gray-100 my-1"></div>
            <a href="#" @click.prevent="handleLogout" class="block px-4 py-2 text-sm text-red-600 hover:bg-gray-100">
              <i class="fas fa-sign-out-alt mr-2"></i>退出登录
            </a>
          </div>
        </transition>
      </div>
    </div>
    <!-- 移动端抽屉菜单 -->
    <transition name="dropdown">
      <div v-if="showMobileMenu" class="fixed inset-0 z-50 bg-black bg-opacity-40 md:hidden" @click.self="showMobileMenu = false">
        <div class="absolute top-0 left-0 w-3/4 max-w-xs h-full bg-white shadow-lg p-6 flex flex-col">
          <button class="self-end mb-6 text-2xl text-gray-700" @click="showMobileMenu = false"><i class="fas fa-times"></i></button>
          <router-link to="/" class="mb-4 text-gray-800 text-lg font-medium" @click.native="showMobileMenu = false">首页</router-link>
          <router-link to="/mall" class="mb-4 text-gray-800 text-lg font-medium" @click.native="showMobileMenu = false">作品商城</router-link>
          <router-link to="/category-list" class="mb-4 text-lg font-medium rainbow-category-link" @click.native="showMobileMenu = false">
            <span v-for="(char, idx) in '定制分类'.split('')" :key="idx" class="rainbow-char" :style="{ animationDelay: (idx * 0.15) + 's' }">{{ char }}</span>
          </router-link>
          <router-link to="/about-us" class="mb-4 text-gray-800 text-lg font-medium" @click.native="showMobileMenu = false">关于我们</router-link>
        </div>
      </div>
    </transition>
  </div>
</nav>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'NavBar',
  data() {
    return {
      isAuthenticated: false,
      username: '',
      avatar: '',
      showDropdown: false,
      showMobileMenu: false
    }
  },
  computed: {
    ...mapGetters('cart', ['totalCount']),
    ...mapGetters('user', ['amount'])
  },
  mounted() {
    this.checkAuthStatus();
    document.addEventListener('click', this.handleClickOutside);
  },
  created() {
    this.checkAuthStatus();
    this.$router.afterEach(() => {
      this.checkAuthStatus();
      this.showDropdown = false;
    });
    if (this.isAuthenticated) {
      this.$store.dispatch('cart/fetchCart');
      this.$store.dispatch('user/fetchUserInfo');
    }
    window.addEventListener('storage', this.handleStorageChange);
    this.$root.$on('auth-change', this.handleAuthChange);
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.handleStorageChange);
    this.$root.$off('auth-change', this.handleAuthChange);
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    checkAuthStatus() {
      const isAuthenticated = localStorage.getItem('isAuthenticated');
      const username = localStorage.getItem('username');
      const avatar = localStorage.getItem('avatar');
      this.isAuthenticated = isAuthenticated === 'true';
      this.username = username || '用户';
      this.avatar = avatar || '';
    },
    toggleDropdown(event) {
      event.stopPropagation();
      this.showDropdown = !this.showDropdown;
    },
    handleStorageChange(event) {
      if (event.key === 'isAuthenticated' || event.key === 'username') {
        this.checkAuthStatus();
      }
      if (event.key === 'avatar') {
        this.checkAuthStatus();
      }
    },
    handleAuthChange(payload) {
      this.isAuthenticated = payload.isAuthenticated;
      this.username = payload.username;
      this.avatar = payload.avatar || '';
      if (this.isAuthenticated) {
        this.$store.dispatch('cart/fetchCart');
        this.$store.dispatch('user/fetchUserInfo');
      } else {
        this.$store.commit('cart/SET_CART_ITEMS', []);
        this.$store.commit('user/setAmount', 0);
      }
    },
    handleLogout() {
      localStorage.removeItem('authToken');
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('username');
      localStorage.removeItem('phone');
      localStorage.removeItem('role');
      localStorage.removeItem('avatar');
      this.isAuthenticated = false;
      this.username = '';
      this.avatar = '';
      this.$store.commit('cart/clearCart');
      this.$root.$emit('auth-change', {
        isAuthenticated: false,
        username: '',
        phone: '',
        role: '',
        avatar: ''
      });
      // 仅在受限页面才跳转首页
      const protectedRoutes = ['/cart', '/user-profile', '/order-confirm', '/order-success', '/order-detail'];
      if (protectedRoutes.includes(this.$route.path)) {
        this.$router.push('/').catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
      this.$message.success({ message: '已成功退出登录', showClose: true });
    },
    handleClickOutside(event) {
      if (this.$el && !this.$el.contains(event.target)) {
        this.showDropdown = false;
      }
    },
    goToCart() {
      // this.$router.push('/cart');
      if (!this.isAuthenticated) {
        this.$router.push({ path: '/login', query: { redirect: '/cart' } });
      } else if (this.$route.path !== '/cart') {
        this.$router.push('/cart');
      }
    },
    goToLogin() {
      if (this.$route.path !== '/login') {
        this.$router.push('/login');
      }
    },
    goToUserProfile() {
      this.showDropdown = false;
      if (this.$route.path !== '/user-profile') {
        this.$router.push('/user-profile');
      }
    }
  }
}
</script>

<style scoped>
.dropdown-enter-active, .dropdown-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.dropdown-enter, .dropdown-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* 七彩渐变动画 */
@keyframes rainbow {
  0% { color: #ff5252; }
  16% { color: #ffb300; }
  32% { color: #ffe600; }
  48% { color: #00e676; }
  64% { color: #00b8ff; }
  80% { color: #8c6eff; }
  100% { color: #ff5252; }
}

/* 跳动动画 */
@keyframes bounce {
  0%, 100% { transform: translateY(0) scale(1); }
  30% { transform: translateY(-8px) scale(1.15); }
  60% { transform: translateY(0) scale(0.95); }
}

.rainbow-category-link .rainbow-char {
  display: inline-block;
  font-weight: bold;
  animation: rainbow 2s linear infinite, bounce 1.2s infinite;
  /* 让每个字动画错开 */
}
</style> 